import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import _ from "lodash";

// export default function MediaCard({width, cardHeight, buttons={}}) {
const MediaCard = (props) => {

  const width = props.width;
  const height = props.cardHeight;
  const buttons = props.buttons || {};
  const title = props.title || "";

  return (
    <Card sx={{ maxWidth: width, backgroundColor: "#333333" }}>
      <CardContent>
        <Typography gutterBottom variant="h5" component="div">
          {title}
        </Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          {props.children}
        </Typography>
      </CardContent>
      <CardActions sx={{justifyContent: "center"}}>
        {!_.isEmpty(buttons) ? Object.entries(buttons).map( ( [key, value] ) => (
            <Button size="small">{value}</Button>
        )):(<></>)}
      </CardActions>
    </Card>
  );
}

export default MediaCard;
